/* global API_URL */

import axios from 'axios'

const http = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  timeout: 5000
})

export default {
  install: function (Vue, name = '$http') {
    Object.defineProperty(Vue.prototype, name, { value: http })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/front/js/plugins/http.js